<template>
  <a-layout-content class="p-all">
    <a-row :gutter="{ xs: 0, lg: 8 }">
      <a-col :xs="24" :lg="8">
        <a-card>
          <span class="m-text-title" slot="title">Filter</span>
          <div class="d-flex flex-column">
            <a-input-search v-model="search" placeholder="Pencarian ... " />
            <a-collapse activeKey="1" class="m-top">
              <a-collapse-panel key="1">
                <span slot="header">Cari Lebih Lengkap</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Tanggal Transaksi</label>
                  <a-range-picker v-model="transactionDt" allowClear />
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </a-card>
      </a-col>
      <a-col :xs="24" :lg="16">
        <H-Datalist
          title="Key Performance Indicator"
          createLink="createSppd"
          manifestLink="kpi"
          editLink="edit"
          :dataListTab1="dataListKPI"
          :dataListTab2="dataDraftKPI"
          titleTab1="KPI List"
          titleTab2="Draft"
        >
          <div slot="action-button">
            <a-button type="primary">
              <router-link
                :to="{ name: kpiCreate, params: { id: 1 } }"
              >
                <a-icon type="plus" /> &nbsp;{{
                  isMobile ? "" : "Baru"
                }}
                </router-link
              >
            </a-button>
          </div>
        </H-Datalist>
      </a-col>
    </a-row>
  </a-layout-content>
</template>

<script>
import DataListTabs from "@/components/DataListTabs";
export default {
  components: {
    "H-Datalist": DataListTabs
  },
  name: "KPI",
  data() {
    return {
      kpiCreate:"kpiCreate",
      transactionDt: [],
      search: "",
      dataListKPI: [
        {
          description: "Infrastructure and implementer staff",
          subdesc: [
            [
              { label: "Total Weigth :", value: "100%" },
              { label: "Total KPI Score :", value: "100%" }
            ]
          ],
          id: "650d778b6532g",
          status: "Approved",
          title: "KPI.NDY/01.24",
          timeline: [
            { actor: "HRD", status: "Approved" },
            { actor: "HRD", status: "Approved" }
          ]
        },
        {
          description: "Infrastructure and implementer staff",
          subdesc: [
            [
              { label: "Total Weigth :", value: "100%" },
              { label: "Total KPI Score :", value: "100%" }
            ]
          ],
          id: "650d778b6532h",
          status: "Approved",
          title: "KPI.NDY/01.24",
          timeline: [
            { actor: "HRD", status: "Approved" },
            { actor: "HRD", status: "Approved" }
          ]
        },
        {
          description: "Infrastructure and implementer staff",
          subdesc: [
            [
              { label: "Total Weigth :", value: "100%" },
              { label: "Total KPI Score :", value: "100%" }
            ]
          ],
          id: "650d778b6532i",
          status: "Approved",
          title: "KPI.NDY/01.24",
          timeline: [
            { actor: "HRD", status: "Approved" },
            { actor: "HRD", status: "Approved" }
          ]
        }
      ],
      dataDraftKPI: [
        {
          description: "Membuat F16",
          subdesc: [
            [
              { label: "Total Weigth :", value: "100%" },
              { label: "Total KPI Score :", value: "100%" }
            ]
          ],
          id: "650d778b6532d",
          status: "Approved",
          title: "KPI.NDY/01.24",
          timeline: [
            { actor: "HRD", status: "Approved" },
            { actor: "HRD", status: "Approved" }
          ]
        }
      ]
    };
  }
};
</script>

<style></style>
